import { DateRange, PaginationParams, SortParams } from './helpers.model';

export enum HistoryEventSource {
  LINKEDIN = 'linkedin',
  GITHUB = 'github',
  STACKOVERFLOW = 'stackoverflow',
  WORK_UA = 'work_ua',
  RABOTA_UA = 'rabota_ua',
  XING = 'xing',
  DRIBBLE = 'dribble',
  MANUALLY = 'manually',
  MY_TALENTS = 'my_talents',
  AURA = 'ai',
}

export interface HistoryEvent {
  createdAt: string;
  entityId: number | string;
  id?: string;
  payload: Record<string, unknown>;
  portalId: number;
  scope: HistoryScope;
  relatedEntities: Array<{ entityId: number | string; scope: HistoryScope }>;
  type: HistoryEventType;
}

export interface HistoryList {
  count: number;
  items: HistoryEvent[];
}

export type HistoryQuery = Partial<DateRange & PaginationParams & SortParams>;

export interface HistoryParams extends HistoryQuery {
  scope: HistoryScope;
  scopeEntityId: number;
}

export interface HistoryState {
  isLoading: boolean;
  items: HistoryEvent[];
  total: number;
  query: HistoryQuery;
}

export type HistoryEventType =
  | 'add_candidate_to_vacancy'
  | 'add_comment_to_profile'
  | 'add_comment_to_shortlist'
  | 'add_comment_to_vacancy'
  | 'book_profile'
  | 'candidate_hired'
  | 'candidate_rejected'
  | 'candidate_status_update'
  | 'change_recruitment_team'
  | 'change_vacancy_assignment'
  | 'change_vacancy_status'
  | 'change_vacancy_data'
  | 'change_vacancy_field_values'
  | 'create_profile'
  | 'create_profile_from_external'
  | 'create_vacancy'
  | 'delete_comment'
  | 'delete_profile_file'
  | 'remove_shortlist'
  | 'open_contacts_profile_page'
  | 'open_contacts_sidepanel'
  | 'open_contacts_candidates_list'
  | 'open_contacts_search_console'
  | 'open_contacts_plugin'
  | 'open_contacts'
  | 'open_profile_in_sidepanel'
  | 'get_profile_details_by_id'
  | 'edit_profile'
  | 'get_profile_details_from_plugin'
  | 'get_public_profile_by_id'
  | 'get_candidates'
  | 'get_profiles'
  | 'get_teams'
  | 'get_my_vacancy_by_id'
  | 'public_apply_to_vacancy'
  | 'get_vacancy_details_by_id'
  | 'unbook_profile'
  | 'update_profile'
  | 'upload_file_to_profile'
  | 'send_notifications'
  | 'send_request_for_get_more_contacts'
  | 'merge_profiles';

export type HistoryScope = 'profile' | 'recruiter' | 'team' | 'vacancy';
